export const TOGGLE_DARK_MODE = '[Settings] toggle  dark mode';

export const toggleDarkMode = () => ({
  type: TOGGLE_DARK_MODE,
});

class ToggleDarkMode {
  readonly type = TOGGLE_DARK_MODE;
}

export type SettingsActionTypes = ToggleDarkMode;
